import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import {
	API_URL_GRANTS as API_URL,
	getObjFromLS,
} from "../../../utils/helpers";

import Alert from "../../../components/Alert";
import Notice from "../../../components/Notice";
import Msg from "../../../components/Msg";
import Submit from "../../../components/Submit";

import Back from "../Back";

import Fields1 from "./Fields1";
import Fields2 from "./Fields2";
import Fields3 from "./Fields3";

import { faChevronCircleRight } from "@fortawesome/pro-light-svg-icons";

const Quest4 = ({ cares }) => {
	const [user, setUser] = useState({});
	const [names, setNames] = useState({});
	const [errors, setErrors] = useState([]);
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef();
	const navigate = useNavigate();
	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;

		if (getObjFromLS("grants")) {
			const obj = getObjFromLS("grants");

			init(obj);
		} else {
			navigate("/enter");
		}
	});

	const init = async ({ token, id, email }) => {
		const url = new URL(`${API_URL}/`);
		const params = {
			admin: 1,
			f: "startedInit",
			token,
			x: uuidv4(),
		};

		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url.href, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setUser({
					token,
					id,
					email,
				});

				const section = json.sections.find(
					(section) => section.key === "quest4"
				);

				setNames((names) => ({
					...names,
					...json.data.quest4,
					descr: section.descr,
				}));

				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: "An error occurred accessing your application.",
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error occurred accessing your application.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/?admin=1&f=quest4`);
		let formData = new FormData(formElement.current);
		formData.append("token", user.token);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				navigate("/", {
					state: {
						type: "success",
						text: json.text,
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			<Back />
			<h2>{names.descr ? names.descr : ""}</h2>
			<p>
				Entry is required in <strong>ALL</strong>{" "}
				<span style={{ color: "var(--error)" }}>*</span> fields to complete this
				section. We have designed the application as such that you can return
				later to update your details, but please note that an entry (you may
				indicate “not applicable”) is required in each{" "}
				<span style={{ color: "var(--error)" }}>*</span> field in order to save
				your progress.
			</p>

			<Notice
				data={{
					text: "Reminder if copying/pasting from a Word document, please save or export from Word as plain text before pasting your content into the answer fields.",
				}}
			/>

			<div className="grants form-container">
				{alert.type ? (
					<Alert data={alert} />
				) : (
					<form
						method="post"
						action="/"
						onSubmit={(e) => handleSubmit(e)}
						ref={formElement}
					>
						<Fields1
							names={{
								percentageFunded: names.percentageFunded,
								percentageFundraised: names.percentageFundraised,
							}}
							handleUpdate={handleUpdate}
							errors={errors}
						/>

						<p
							className="line"
							style={{ marginTop: "10px", marginBottom: "15px" }}
						/>

						<Fields2
							names={{
								support: names.support,
								members: names.members,
								personally: names.personally,
							}}
							handleUpdate={handleUpdate}
							errors={errors}
						/>

						<p
							className="line"
							style={{ marginTop: "10px", marginBottom: "15px" }}
						/>

						<Fields3
							names={{
								revenue: names.revenue,
								expenses: names.expenses,
								profit: names.profit,
								assets: names.assets,
								liabilities: names.liabilities,
								net: names.net,
							}}
							handleUpdate={handleUpdate}
							errors={errors}
						/>

						<div className="msg-submit">
							{msg.type && <Msg data={msg} />}

							<div
								className={
									msg.type === "working" ? "hidden" : "submit-container"
								}
							>
								<Submit
									name="Submit Answers"
									icon={faChevronCircleRight}
									cares={cares}
								/>
							</div>
						</div>
					</form>
				)}
			</div>
		</>
	);
};

export default Quest4;
